import { lazy, Suspense, useCallback, useState } from 'react';
import { staffSession } from '../lib/owner';
import { navigate } from '../lib/router';
import { Shell } from './Shell';
import { useStaff } from './useStaff';

const Planner = lazy(() => import('./floor3d/Planner'));

/** /floor/edit — owners only: the 3D floor planner. */
export function FloorEdit({ path }: { path: string }) {
  const { s, online } = useStaff(() => undefined, () => undefined);
  const [noGl, setNoGl] = useState(false);
  const onFail = useCallback(() => setNoGl(true), []);
  const owner = staffSession()?.role === 'owner';
  return (
    <Shell path="/floor" online={online} sub="จัดร้าน · Floor planner">
      {!owner ? (
        <div className="panel"><p style={{ margin: 0 }}>เฉพาะเจ้าของร้าน · Only the owner can change the floor plan.</p></div>
      ) : noGl ? (
        <div className="panel">
          <p style={{ marginTop: 0 }}>เครื่องนี้แสดง 3D ไม่ได้ ลองบนคอมพิวเตอร์หรือแท็บเล็ตเครื่องอื่น · This device can't draw 3D. Try another computer or tablet.</p>
          <button className="btn-dark" onClick={() => navigate('/floor')}>กลับ · Back</button>
        </div>
      ) : s ? (
        <Suspense fallback={<div className="stage3d planner"><div className="spinner" role="status" aria-label="Loading planner" style={{ margin: 'auto' }} /></div>}>
          <Planner token={s.token} onFail={onFail} />
        </Suspense>
      ) : null}
      <span hidden>{path}</span>
    </Shell>
  );
}
